module.exports = {"510303001":"筱溪街道","510303002":"贡井街道","510303100":"艾叶镇","510303101":"建设镇","510303102":"长土镇","510303104":"龙潭镇","510303105":"桥头镇","510303106":"五宝镇","510303107":"莲花镇","510303108":"成佳镇","510303109":"白庙镇","510303200":"章佳乡","510303201":"牛尾乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510303.json
// module id = 2276
// module chunks = 0